import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import AutoForm from "react-auto-form";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

//import { ToastContainer, toast } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class E_MonitoringNoteSupply extends Component {
    //constructor(props) {
    //    super(props);
    //    this.state = {
    //        lastOnChange: null,
    //        lastOnSubmit: null,
    //        trim: true,
    //        trimOnSubmit: false
    //    };
    //}

    //_onChange = (e, name, data, change) => {
    //    console.log(data);
    //    this.setState({ lastOnChange: { name, data, change } });
    //};

    //_onSubmit = (e, data) => {
    //    console.log("submit");
    //    console.log(data);
    //    this.setState({ lastOnSubmit: { data } });
    //    e.preventDefault();
    //};

    //_onOptionsChange = (e, name, data, change) => {
    //    console.log(data);
    //    this.setState(change);
    //};

    ////handleSave = () => {
    ////    //console.log("ID: " + this.state.projectId);

    ////    for (var key in this.state) {
    ////        console.log(key + ": " + this.state[key]);
    ////    }
    ////};

    //render() {
    //    //let { lastOnChange, lastOnSubmit, trim, trimOnSubmit } = this.state;
    //    let { trim, trimOnSubmit } = this.state;


    constructor(props) {
        super(props);
        this.state = {
            missionId: props.propMissionId,
            lastOnChange: null,
            lastOnSubmit: null,
            trim: false,
            trimOnSubmit: false,
            pageLoadData: {},
            templateId: props.propTemplateId,
            countOtherDocuments: 1,
            countPerson: 1,
            interviewPersonCategories: [
                { TypeId: 1, TypeName: "Beneficiary" },
                { TypeId: 2, TypeName: "Partner Country" },
                { TypeId: 3, TypeName: "Stakeholder" },
                { TypeId: 4, TypeName: "Other" },
                { TypeId: 5, TypeName: "DEUA" },
                { TypeId: 6, TypeName: "EU Delegation" },
                { TypeId: 7, TypeName: "Contracting Authority" },
                { TypeId: 8, TypeName: "End Beneficiary" },
                { TypeId: 9, TypeName: "Lead Institution" },
                { TypeId: 10, TypeName: "Contractor" },
                { TypeId: 11, TypeName: "Final Beneficiary" },
            ],
        };
    }

    _onChange = (e, name, data, change) => {
        console.log(data)

        var pageLoadDataChange = this.state.pageLoadData;
        pageLoadDataChange[name] = data;

        this.setState({
            lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

    }

    _onSubmit = (e, data) => {
        console.log("submit");
        this.setState({ lastOnSubmit: { data } });

        let dataToSubmit = data;
        dataToSubmit["missionId"] = this.state.missionId;
        dataToSubmit["templateId"] = this.state.templateId;
        dataToSubmit["countOtherDocuments"] = this.state.countOtherDocuments;
        dataToSubmit["countPerson"] = this.state.countPerson;
        console.log(dataToSubmit);

        this.props.propUpdatePageLoadData(dataToSubmit);

        fetch(global.variables.API_TEMPLATEFILLER_FILLANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(dataToSubmit)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        e.preventDefault();
    }

    _onOptionsChange = (e, name, data, change) => {
        console.log(data);
        this.setState(change);
    };

    async componentDidMount() {
        await fetch(global.variables.API_TEMPLATEFILLER_GETANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                operation: "GetExpostMq",
                missionId: this.state.missionId,
                templateId: this.state.templateId
            })
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.saveddata.length > 0) {
                    this.setState({ pageLoadData: JSON.parse(result.saveddata[0].TemplateAnswers) });

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments > 0) {
                        this.setState({
                            countOtherDocuments: JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments,
                        });
                    } else {
                        this.setState({
                            countOtherDocuments: 1,
                        });
                    }

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countPerson !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countPerson > 0) {
                        this.setState({
                            countPerson: JSON.parse(result.saveddata[0].TemplateAnswers).countPerson,
                        });
                    } else {
                        this.setState({
                            countPerson: 1,
                        });
                    }
                }
            });

        this.props.propUpdatePageLoadData(this.state.pageLoadData);
    }

    checkIfChecked = (element, value) => {
        if (element === value) {
            return true;
        } else {
            return false;
        }
    };

    incrementOtherDocuments = () => {
        var countOtherDocuments = this.state.countOtherDocuments;

        if (countOtherDocuments < 20) {
            countOtherDocuments += 1;
        }

        this.setState({ countOtherDocuments: countOtherDocuments });
    }

    incrementPerson = () => {
        var countPerson = this.state.countPerson;

        if (countPerson < 20) {
            countPerson += 1;
        }

        this.setState({ countPerson: countPerson });
    }

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleSelectChangeUseValue = async (e, v, vname) => {
        e.persist();

        //console.log(data)
        //this.setState({ lastOnChange: { name, data, change } })

        var pageLoadDataChange = this.state.pageLoadData;
        //pageLoadDataChange[vname] = v.TypeName;
        if (v !== undefined & v !== null) {
            pageLoadDataChange[vname] = v.TypeId;
        } else {
            pageLoadDataChange[vname] = -1;
        }

        this.setState({
            //lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

        //if (v !== undefined & v !== null) {
        //    await this.setState({ [vname]: v.TypeName });
        //} else {
        //    await this.setState({ [vname]: "" });
        //}

        console.log(this.state);
    }

    handleSelectChangePageLoadData = async (e, v, vname) => {

        //console.log("handleSelectChangePageLoadData vId: " + v.TypeId + " vName: " + v.TypeName + " vname: " + vname);

        e.persist();

        //console.log(data)
        //this.setState({ lastOnChange: { name, data, change } })

        var pageLoadDataChange = this.state.pageLoadData;
        //pageLoadDataChange[vname] = v.TypeName;
        if (v !== undefined & v !== null) {
            //pageLoadDataChange[vname] = v.TypeId;
            pageLoadDataChange[vname] = v.TypeName;
        } else {
            pageLoadDataChange[vname] = -1;
        }

        this.setState({
            //lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

        console.log(this.state);
    }

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId === element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    returnArrayElementUseValue = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeName === element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    render() {
        let {
            trim,
            trimOnSubmit,
            pageLoadData,
            countOtherDocuments,
            countPerson,
            interviewPersonCategories,
        } = this.state;
        return (
            <Grid container>
                <AutoForm
                    onSubmit={this._onSubmit}
                    onChange={this._onChange}
                    trim={!!trim}
                    trimOnSubmit={!!trimOnSubmit}
                    style={{ width: "100%" }}
                >
                    <Grid item xs={12}>
                        <p>Scoring</p>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Relevance</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmsS1Relevance" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmsS1Relevance, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmsS1Relevance, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmsS1Relevance, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Efficiency</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmsS2Efficiency" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmsS2Efficiency, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmsS2Efficiency, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmsS2Efficiency, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Effectiveness</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmsS3Effectiveness" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmsS3Effectiveness, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmsS3Effectiveness, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmsS3Effectiveness, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Impact</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmsS4Impact" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmsS4Impact, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmsS4Impact, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmsS4Impact, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Sustainability</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmsS5Sustainability" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmsS5Sustainability, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmsS5Sustainability, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmsS5Sustainability, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>1. Relevance </p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    1.1 Were the supplies identified in the Supply Contact in line with the target groups / end beneficiaries needs?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ1Were" rows={6} defaultValue={this.state.pageLoadData.EmsQ1Were} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    1.2 Was the beneficiary involved in the definition of the supply of goods?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ2Was" rows={6} defaultValue={this.state.pageLoadData.EmsQ2Was} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>1.3 Define the type of supplies provided.</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ3Define" rows={6} defaultValue={this.state.pageLoadData.EmsQ3Define} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    1.4a Were indicators been defined to measure the delivery of the supplies?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ4Were" rows={6} defaultValue={this.state.pageLoadData.EmsQ4Were} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    1.4b Have all related data available on the tendering, evaluation and provision of supplies available?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ5Have" rows={6} defaultValue={this.state.pageLoadData.EmsQ5Have} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <br />
                        <p>2. Efficiency</p>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    2.1 Did the supplies funded by the action correspond to the needs
                                    of the action?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ6Did" rows={6} defaultValue={this.state.pageLoadData.EmsQ6Did} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    2.2 Was there delays encountered and how important were they and
                                    what were the consequences on the project?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ7Was" rows={6} defaultValue={this.state.pageLoadData.EmsQ7Was} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    2.3 What are the reasons for the delays and to what extent have
                                    appropriate corrective measures been implemented?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ8What" rows={6} defaultValue={this.state.pageLoadData.EmsQ8What} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>3. Effectiveness</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    3.1 How satisfactory is the quality of the supplies for the recipients?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ9How" rows={6} defaultValue={this.state.pageLoadData.EmsQ9How} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>4. Impact</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    4.1 Identify the impact of the delivery of the provided supplies
                                    for both the medium and long term?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ10Identify" rows={6} defaultValue={this.state.pageLoadData.EmsQ10Identify} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    4.2 What is the impact of the supplies on the project
                                    stakeholders? had an indirect positive and/or a negative
                                    impact?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ11What" rows={6} defaultValue={this.state.pageLoadData.EmsQ11What} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    4.3 Has there been any indirect positive and/or a negative impact?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ12Has" rows={6} defaultValue={this.state.pageLoadData.EmsQ12Has} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>5. Sustainability</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    5.1 Did key stakeholders acquire the necessary skills to benefit
                                    from the delivery of supplies?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ13Did" rows={6} defaultValue={this.state.pageLoadData.EmsQ13Did} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    5.2 Are the benefits of the supplies for target groups affordable
                                    in the long term?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ14Are" rows={6} defaultValue={this.state.pageLoadData.EmsQ14Are} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    5.3 Has the relevant authorities taken the financial measure(s) to
                                    ensure maintenance of the supplies (if relevant) after the
                                    delivery of supplies?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ15Has" rows={6} defaultValue={this.state.pageLoadData.EmsQ15Has} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    5.4 Has the private sector been involved in maintaining supplies?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ16Has" rows={6} defaultValue={this.state.pageLoadData.EmsQ16Has} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    5.5 Have the necessary measures been taken to address the
                                    environmental sustainability?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ17Have" rows={6} defaultValue={this.state.pageLoadData.EmsQ17Have} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        {
                            //      <ExpansionPanel>
                            //          <ExpansionPanelSummary
                            //              expandIcon={<ExpandMoreIcon />}
                            //              aria-controls="panel2a-content"
                            //              id="panel2a-header"
                            //          >
                            //              <Typography>
                            //                  Have the necessary measures been taken to address the
                            //environmental sustainability?
                            //          </Typography>
                            //          </ExpansionPanelSummary>
                            //          <ExpansionPanelDetails>
                            //              <Grid item xs container direction="column" spacing={2}>
                            //                  <TextareaAutosize name="EmsQ18Have" rows={6} defaultValue={this.state.pageLoadData.EmsQ18Have} />
                            //              </Grid>
                            //          </ExpansionPanelDetails>
                            //      </ExpansionPanel>
                        }

                        <br />
                        <p>6. Horizontal</p>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    6.1 Have the communication and visibility actions been implemented
                                    in an appropriate manner?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ19Have" rows={6} defaultValue={this.state.pageLoadData.EmsQ19Have} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>
                                    6.2 Was the supply in line with the requirements of the other
                                    components of the current project (if applicable)?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsQ20Was" rows={6} defaultValue={this.state.pageLoadData.EmsQ20Was} />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>




                        <br />
                        <br />
                        <p><b>Sources of Information: List all documents analysed</b></p>
                        <p>Essential Project/Programme documents</p>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Action Documents</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmsC1ProjectDocuments" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmsC1ProjectDocuments, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmsC1ProjectDocuments, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmsC1ProjectDocuments, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Financing/Contribution/Delegation/Administration Agreement or grant contract</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                In these documents, all annexes are to be included such as Technical and Administrative provisions, Implementation schedule, logframe (incl. updates)
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmsC2FinancingContribution" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmsC2FinancingContribution, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmsC2FinancingContribution, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmsC2FinancingContribution, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Riders to all the documents listed above and their explanatory notes</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmsC3Riders" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmsC3Riders, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmsC3Riders, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmsC3Riders, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Annual and overall activity schedules/implementation plans</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmsC4Annual" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmsC4Annual, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmsC4Annual, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmsC4Annual, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Implementation progress reports</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmsC5Implementation" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmsC5Implementation, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmsC5Implementation, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmsC5Implementation, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <br />
                        <p>Other Documents</p>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Other Documents</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 0 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD1" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 0 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD1} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 1 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD2" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 1 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD2} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 2 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD3" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 2 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD3} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 3 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD4" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 3 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD4} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 4 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD5" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 4 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD5} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 5 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD6" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 5 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD6} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 6 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD7" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 6 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD7} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 7 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD8" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 7 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD8} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 8 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD9" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 8 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD9} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 9 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD10" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 9 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD10} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 10 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD11" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 10 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD11} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 11 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD12" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 11 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD12} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 12 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD13" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 12 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD13} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 13 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD14" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 13 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD14} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 14 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD15" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 14 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD15} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 15 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD16" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 15 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD16} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 16 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD17" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 16 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD17} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 17 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD18" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 17 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD18} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 18 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD19" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 18 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD19} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 19 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmsOtherDocumentsD20" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 19 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmsOtherDocumentsD20} />
                                </Grid>
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementOtherDocuments.bind(this)}
                                    >
                                        Add Documents
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>


                        <br />
                        <p><b>Sources of Information: List of persons interviewed</b></p>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>List Of Persons Interviewed</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countPerson > 0 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP1PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP1PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP1PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP1PersonName"
                                    value={pageLoadData.EmsSOIP1PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP1PersonEmail"
                                    value={pageLoadData.EmsSOIP1PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP1PersonPosition"
                                    value={pageLoadData.EmsSOIP1PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP1PersonInstitution"
                                    value={pageLoadData.EmsSOIP1PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 1 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP2PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP2PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP2PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP2PersonName"
                                    value={pageLoadData.EmsSOIP2PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP2PersonEmail"
                                    value={pageLoadData.EmsSOIP2PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP2PersonPosition"
                                    value={pageLoadData.EmsSOIP2PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP2PersonInstitution"
                                    value={pageLoadData.EmsSOIP2PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 2 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP3PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP3PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP3PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP3PersonName"
                                    value={pageLoadData.EmsSOIP3PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP3PersonEmail"
                                    value={pageLoadData.EmsSOIP3PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP3PersonPosition"
                                    value={pageLoadData.EmsSOIP3PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP3PersonInstitution"
                                    value={pageLoadData.EmsSOIP3PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 3 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP4PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP4PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP4PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP4PersonName"
                                    value={pageLoadData.EmsSOIP4PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP4PersonEmail"
                                    value={pageLoadData.EmsSOIP4PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP4PersonPosition"
                                    value={pageLoadData.EmsSOIP4PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP4PersonInstitution"
                                    value={pageLoadData.EmsSOIP4PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 4 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP5PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP5PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP5PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP5PersonName"
                                    value={pageLoadData.EmsSOIP5PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP5PersonEmail"
                                    value={pageLoadData.EmsSOIP5PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP5PersonPosition"
                                    value={pageLoadData.EmsSOIP5PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP5PersonInstitution"
                                    value={pageLoadData.EmsSOIP5PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 5 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP6PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP6PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP6PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP6PersonName"
                                    value={pageLoadData.EmsSOIP6PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP6PersonEmail"
                                    value={pageLoadData.EmsSOIP6PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP6PersonPosition"
                                    value={pageLoadData.EmsSOIP6PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP6PersonInstitution"
                                    value={pageLoadData.EmsSOIP6PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 6 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP7PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP7PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP7PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP7PersonName"
                                    value={pageLoadData.EmsSOIP7PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP7PersonEmail"
                                    value={pageLoadData.EmsSOIP7PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP7PersonPosition"
                                    value={pageLoadData.EmsSOIP7PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP7PersonInstitution"
                                    value={pageLoadData.EmsSOIP7PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 7 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP8PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP8PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP8PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP8PersonName"
                                    value={pageLoadData.EmsSOIP8PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP8PersonEmail"
                                    value={pageLoadData.EmsSOIP8PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP8PersonPosition"
                                    value={pageLoadData.EmsSOIP8PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP8PersonInstitution"
                                    value={pageLoadData.EmsSOIP8PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 8 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP9PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP9PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP9PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP9PersonName"
                                    value={pageLoadData.EmsSOIP9PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP9PersonEmail"
                                    value={pageLoadData.EmsSOIP9PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP9PersonPosition"
                                    value={pageLoadData.EmsSOIP9PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP9PersonInstitution"
                                    value={pageLoadData.EmsSOIP9PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 9 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP10PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP10PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP10PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP10PersonName"
                                    value={pageLoadData.EmsSOIP10PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP10PersonEmail"
                                    value={pageLoadData.EmsSOIP10PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP10PersonPosition"
                                    value={pageLoadData.EmsSOIP10PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP10PersonInstitution"
                                    value={pageLoadData.EmsSOIP10PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 10 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP11PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP11PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP11PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP11PersonName"
                                    value={pageLoadData.EmsSOIP11PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP11PersonEmail"
                                    value={pageLoadData.EmsSOIP11PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP11PersonPosition"
                                    value={pageLoadData.EmsSOIP11PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP11PersonInstitution"
                                    value={pageLoadData.EmsSOIP11PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 11 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP12PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP12PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP12PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP12PersonName"
                                    value={pageLoadData.EmsSOIP12PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP12PersonEmail"
                                    value={pageLoadData.EmsSOIP12PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP12PersonPosition"
                                    value={pageLoadData.EmsSOIP12PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP12PersonInstitution"
                                    value={pageLoadData.EmsSOIP12PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 12 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP13PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP13PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP13PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP13PersonName"
                                    value={pageLoadData.EmsSOIP13PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP13PersonEmail"
                                    value={pageLoadData.EmsSOIP13PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP13PersonPosition"
                                    value={pageLoadData.EmsSOIP13PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP13PersonInstitution"
                                    value={pageLoadData.EmsSOIP13PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 13 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP14PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP14PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP14PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP14PersonName"
                                    value={pageLoadData.EmsSOIP14PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP14PersonEmail"
                                    value={pageLoadData.EmsSOIP14PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP14PersonPosition"
                                    value={pageLoadData.EmsSOIP14PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP14PersonInstitution"
                                    value={pageLoadData.EmsSOIP14PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 14 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP15PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP15PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP15PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP15PersonName"
                                    value={pageLoadData.EmsSOIP15PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP15PersonEmail"
                                    value={pageLoadData.EmsSOIP15PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP15PersonPosition"
                                    value={pageLoadData.EmsSOIP15PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP15PersonInstitution"
                                    value={pageLoadData.EmsSOIP15PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 15 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP16PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP16PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP16PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP16PersonName"
                                    value={pageLoadData.EmsSOIP16PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP16PersonEmail"
                                    value={pageLoadData.EmsSOIP16PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP16PersonPosition"
                                    value={pageLoadData.EmsSOIP16PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP16PersonInstitution"
                                    value={pageLoadData.EmsSOIP16PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 16 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP17PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP17PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP17PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP17PersonName"
                                    value={pageLoadData.EmsSOIP17PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP17PersonEmail"
                                    value={pageLoadData.EmsSOIP17PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP17PersonPosition"
                                    value={pageLoadData.EmsSOIP17PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP17PersonInstitution"
                                    value={pageLoadData.EmsSOIP17PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 17 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP18PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP18PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP18PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP18PersonName"
                                    value={pageLoadData.EmsSOIP18PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP18PersonEmail"
                                    value={pageLoadData.EmsSOIP18PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP18PersonPosition"
                                    value={pageLoadData.EmsSOIP18PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP18PersonInstitution"
                                    value={pageLoadData.EmsSOIP18PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 18 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP19PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP19PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP19PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP19PersonName"
                                    value={pageLoadData.EmsSOIP19PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP19PersonEmail"
                                    value={pageLoadData.EmsSOIP19PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP19PersonPosition"
                                    value={pageLoadData.EmsSOIP19PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP19PersonInstitution"
                                    value={pageLoadData.EmsSOIP19PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 19 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmsSOIP20PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmsSOIP20PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmsSOIP20PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP20PersonName"
                                    value={pageLoadData.EmsSOIP20PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP20PersonEmail"
                                    value={pageLoadData.EmsSOIP20PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP20PersonPosition"
                                    value={pageLoadData.EmsSOIP20PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmsSOIP20PersonInstitution"
                                    value={pageLoadData.EmsSOIP20PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementPerson.bind(this)}
                                    >
                                        Add Person
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>




                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }} className="mt-1">
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit">
                            SAVE
                        </Button>
                    </Grid>
                </AutoForm>
            </Grid>
        );
    }
}





// WEBPACK FOOTER //
// ./src/pages/E_MonitoringNoteSupply.js